import { render, staticRenderFns } from "./LicenseSettings.vue?vue&type=template&id=728e116c&scoped=true&"
import script from "./LicenseSettings.vue?vue&type=script&lang=js&"
export * from "./LicenseSettings.vue?vue&type=script&lang=js&"
import style0 from "./LicenseSettings.vue?vue&type=style&index=0&id=728e116c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e116c",
  null
  
)

export default component.exports